import React from 'react';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ManualEvaluatorIobItem from '../../../../Domain/ManualEvaluatorIobItem';
import TpClientInvoiceJobLineService from '../../../../Services/TpClientInvoiceJobLineService';

export default class GenerateEvaluatorIobWindowDescription extends React.Component {
  static titleForCreate = 'Generate Evaluator IOB';
  static titleForEdit = 'Generate Evaluator IOB';
  static itemType = ManualEvaluatorIobItem;
  // On success the wizard opens the created IOB (response.navigationId) on the IOB Details page.
  static navigateToOnCreation = '/iobdetails?id=';

  static serviceFunction = (edited) =>
    TpClientInvoiceJobLineService.GenerateManualEvaluatorIob(
      edited,
      GenerateEvaluatorIobWindowDescription.getSelected(),
      GenerateEvaluatorIobWindowDescription.getTpClientInvoiceId()
    );

  static getSelected() {
    return [];
  }

  static getTpClientInvoiceId() {
    return 0;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'Evaluator IOB',
      fields: [
        {
          fieldName: 'InvoicingOfficeId',
          label: 'Invoicing Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'InvoicedOfficeId',
          label: 'Invoiced Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'InternalReference',
          label: 'Internal Ref.',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
